<template>
  <div class="newPage1 w-main">
    <div class="listBox" v-for="(item, index) in list" :key="index">
      <div class="listImg">
        <el-image :src="item.cover" fit="fill"></el-image>
      </div>
      <div class="listMain">
        <div class="listMain-title">{{ item.title }}</div>
        <div class="listMain-text">{{ item.subtitle }}</div>
        <div class="listMain-time">{{ item.publishDate | timeData }}</div>
      </div>
      <router-link
        :to="{
          path: '/new/details',
          query: { title: tabName, id: item.id }
        }"
        tag="div"
        class="listMover"
      >
        了解更多 >
      </router-link>
    </div>
    <div v-if="list.length === 0" class="t-c">暂无数据</div>
  </div>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      default: () => {
        return [];
      }
    },
    tabName: {
      type: String,
      default: ""
    }
  },
  components: {}
};
</script>

<style lang="less">
.newPage1 {
  .listBox {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    margin-bottom: 50px;
    width: 100%;
    .listImg {
      width: 220px;
      height: 150px;
      overflow: hidden;
      background: rgba(230, 232, 235, 1);
    }
    .listMain {
      width: calc(100% - 350px);
      margin: 0 20px;
      &-title {
        height: 30px;
        font-size: 18px;
        font-weight: bold;
        color: rgba(52, 52 52, 1);
        line-height: 30px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
      }
      &-text {
        height: 90px;
        line-height: 30px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        font-size: 14px;
        font-weight: 400;
        color: rgba(153, 153, 153, 1);
      }
      &-time {
        height: 30px;
        line-height: 30px;
        font-size: 14px;
        font-weight: 400;
        color: rgba(153, 153, 153, 1);
      }
    }
    .listMover {
      width: 70px;
      font-size: 14px;
      font-weight: 400;
      color: rgba(22, 82, 148, 1);
      line-height: 24px;
      cursor: pointer;
    }
  }
  .t-c {
    text-align: center;
  }
}
</style>
